import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WarehouseMapApiAdapter } from '../adapters/WarehouseMapApiAdapter';

export const useUpdateRack = (warehouseId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WarehouseMapApiAdapter(httpClient);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ rackId, payload }: { rackId: number; payload: { shelves?: number; slots_per_shelf?: number } }) =>
      adapter.updateRack(warehouseId, rackId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['warehouse-racks', warehouseId] });
      queryClient.invalidateQueries({ queryKey: ['warehouse-heatmap', warehouseId] });
    },
  });
};
